import { usePlatform } from "@platform/PlatformContext";
import { useTalkJSData } from "./useChat";

export function useChatStatusWithCircles() {
  const { userCircles } = usePlatform();
  const talkjs = useTalkJSData();
  
  const isChatEnabled = () => {
    if (!talkjs) return false;
    
    const { chat_status, chat_circle_ids } = talkjs;
    
    // If status is "off", chat is disabled for everyone
    if (chat_status === "off") return false;
    
    // If status is "on", chat is enabled for everyone
    if (chat_status === "on") return true;
    
    // Parse comma-separated circle IDs and convert to integers
    const configuredIds = chat_circle_ids 
      ? chat_circle_ids.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
      : [];
    
    // Get user's circle IDs and convert to integers
    const userCircleIds = userCircles?.map(circle => parseInt(circle.id)).filter(id => !isNaN(id)) || [];
    
    // If status is "exclude", check if any circle IDs are in the exclude list
    if (chat_status === "exclude") {
      return !userCircleIds.some(circleId => configuredIds.includes(circleId));
    }
    
    // If status is "include", check if any circle IDs are in the include list
    if (chat_status === "include") {
      return userCircleIds.some(circleId => configuredIds.includes(circleId));
    }
    
    // Default to enabled if status is unknown
    return true;
  };
  
  return {
    isChatEnabled: isChatEnabled(),
    isLoading: !talkjs,
    error: null,
    chatStatus: talkjs
  };
}
